// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3jeUS","box":"WorkspacesBox_box__1A7WH","node":"WorkspacesBox_node__2_cAZ"};